import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { FormField } from '../../_shared/formfield/formfield.component'; // React-helmet handles document head modifications (title, meta data etc)
import SubmissionHandler from '../../_shared/submissionhandler/submissionhandler';
import Header from '../../_shared/header/header';
import Footer from '../../_shared/footer/footer';
import flatten from '../../_shared/util/flatten';
import getTitles from '../../_shared/util/getTitles';
import { Helmet } from 'react-helmet';
import EmailLinkModal from '../../_shared/emaillink/emaillinkmodal.component';

@inject('livingRoomStore', 'appStore', 'routerStore', 'store', 'form')
@observer
export class FloorComponent extends Component {
    constructor(props) {
        super(props);
        this.emailModal = React.createRef();
    }

    onNext() {
        const { livingRoomStore, routerStore } = this.props,
            { history } = routerStore;

        history.push({ pathname: `/livingroom/${livingRoomStore.currentRoomNum}/ceiling`, state: { transition: 'forward' } });
    }

    onPrevious() {
        const { livingRoomStore, routerStore, store, form } = this.props,
            { history } = routerStore;

        store.save(form.values(), false);
        history.push({ pathname: `/livingroom/${livingRoomStore.currentRoomNum}/walls`, state: { transition: 'back' } });
    }

    render() {
        const { form, store, livingRoomStore, appStore } = this.props,
            errors = form.errors(),
            titles = getTitles(livingRoomStore.currentRoomNum, 'Floor details'),
            idPrefix = `floor-${livingRoomStore.currentRoomNum}`,
            prevActionName = `prev-${livingRoomStore.currentRoomNum}-floor-to-walls`,
            nextActionName = `next-${livingRoomStore.currentRoomNum}-floor-to-ceiling`,
            emailActionName = `email-${livingRoomStore.currentRoomNum}-floor`;

        return <section className='ht-page ht-floor'>
            <Helmet>
                <title>{titles.title} &raquo; {appStore.baseTitle}</title>
            </Helmet>
            <Header
                titlePre={titles.titlePre}
                title={titles.title}
                idPrefix={idPrefix}
                prevActionName={prevActionName}
                emailActionName={emailActionName}
                prev={{
                    onClick: () => this.onPrevious()
                }}
                email={{
                    modal: this.emailModal
                }}
            />
            <SubmissionHandler store={store}>
                <form className='ht-form'>
                    {form.map((field) => {
                        if (field.extra && field.extra.showIf && !field.extra.showIf()) {
                            return null;
                        }

                        field.errors = errors[field.path];
                        return (
                            <FormField
                                key={field.id}
                                field={field}
                                formValues={flatten(form.values())}
                            />
                        );
                    })}
                    <Footer
                        idPrefix={idPrefix}
                        prevActionName={prevActionName}
                        nextActionName={nextActionName}
                        emailActionName={emailActionName}
                        next={{
                            text: 'Go to ceiling details',
                            loading: store.loading,
                            disabled: !form.isValid || (store.error && store.error.code),
                            onClick: e => form.onSubmit(e)
                        }}
                        prev={{
                            onClick: () => this.onPrevious()
                        }}
                        showEmail
                        email={{
                            modal: this.emailModal
                        }}
                        showError={!form.isValid}
                        errorMessage={form.error}
                        emailProgressLinkSupText={window.HTContent.EmailProgressLinkSupText}
                    />
                </form>
            </SubmissionHandler>
            <EmailLinkModal
                ref={this.emailModal}
                onOpenCallback={() => store.save(form.values(), false)}
            />
        </section>;
    }
}
